import Vue from 'vue';
import Component from 'vue-class-component';
import { fProduct, sfProduct } from '@/api/product';
import REQ_URL from '@/consts/req-url';
import ProductListContainer from '@/components/ProductListContainer/ProductListContainer';
import Slider from '@/components/Slider/Slider';
import SliderElement from '@/components/Slider/SliderElement';
import { SwiperOptions } from 'swiper';
import checkItemCount from '@/api/checkItemCount';
import isNumber from '@/api/isNumber';
import autoSelect from '@/api/autoSelect';
import ProductDocuments from '@/components/ProductDocuments/ProductDocuments';
import ProductPhotosDownload from '@/components/ProductPhotosDownload/ProductPhotosDownload';

@Component({
    components: {
        ProductListContainer,
        ProductDocuments,
        ProductPhotosDownload,
        Slider,
        SliderElement,
    },
    beforeRouteUpdate(this: Product, to, from, next) {
        this.setProduct(to.params.id)
        next()
    },
})
export default class Product extends Vue {
    product: fProduct | null = null
    count = 1
    error = ''

    loading = true
    сurrentSlide = 0
    breakpointsMini: SwiperOptions['breakpoints'] = {
        414: {
            slidesPerView: 4,
        },
        599: {
            slidesPerView: 5,
        },
        960: {
            slidesPerView: 3,
        }
    }

    emptyIcon = 'mdi-heart-outline'
    fullIcon = 'mdi-heart'
    halfIcon = 'mdi-heart-half-full'
    halfIncrements = false
    hover = false
    length = 3
    readonly = true
    get fullScore() {
        return this.product && +this.product.Наличие ?
            +this.product.Наличие > 100 ?
                +this.product.Наличие > 300 ?
                    3
                    : 2
                : 1
            : 0;
    }
    addToBasket() {
        this.$store.dispatch('addProductToBasket', {
            product: this.product,
            quiet: false
        })
        this.$nextTick(() => this.updateCount(1))

        if ((document as any).activeElement) (document as any).activeElement.blur();
    }

    updateCount(count: number) {
        if (!this.product) return;
        let oldVal = this.count;
        this.count = count;
        this.product.quantity = this.count
        this.$nextTick(() => {
            if (!this.product) return;
            this.count = checkItemCount(+count, oldVal);
            this.product.quantity = this.count
        })
    }
    numberFilter(e: KeyboardEvent, count: number) {
        if (!isNumber(e.key)) e.preventDefault();
    }
    async loadingProduct(id: string) {
        try {
            let data = await this.$fetch<sfProduct>(REQ_URL.GET_PRODUCT + `?id=${id}`)
            if (data.body) {
                this.product = new fProduct(data.body)
            } else throw new Error('Некорректные данные запроса')
        } catch (error) {
            console.log(error)
            this.error = error.message
        }
        this.loading = false
    }
    async setProduct(id: string) {
        this.$store.commit('modal:open', {
            type: 'loading',
            msg: 'Идёт загрузка'
        })
        await this.loadingProduct(id)
        this.$store.commit('modal:close')
    }
    autoSelect = autoSelect
    showImage(photo: string) {
        this.$nextTick(() => {
            this.$store.commit('image:show', photo)
        })
    }
    mounted() {
        this.setProduct(this.$route.params.id)
    }
}